<template>
  <div>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-clipboard-file-outline
          </v-icon>
          収集運搬業者
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row><!-- /ヘッダー -->

    <!-- 検索ブロック -->
    <v-row>
      <v-col>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-title></v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="subscriber_number"
                        dense
                        hide-details="auto"
                        label="加入者番号"
                        clearable
                        persistent-placeholder
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="name"
                        dense
                        hide-details="auto"
                        label="加入者名"
                        placeholder="部分一致"
                        clearable
                        persistent-placeholder
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-checkbox
                        v-model="unregisterTrader"
                        dense
                        hide-details="auto"
                        label="JWNET未連携のみ"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" @click="searchButtonClickEvent">
                    <v-icon>
                      mdi-magnify
                    </v-icon>
                    &nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- /検索ブロック -->

    <v-row>
      <v-col class="text-left">
        <h4>
          {{ total_count }} 件
        </h4>
      </v-col>
      <v-col class="text-right">
        <v-btn
          color="info"
          @click="addSubscriberButtonClickEvent"
        >
          <v-icon>mdi-plus</v-icon>&nbsp;収集運搬業者の追加
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card class="rounded-card">
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="transports"
              disable-pagination
              :items-per-page="-1"
              disable-sort
              hide-default-footer
            >
              <template v-slot:[`item.name`]="{ item }">
                <span v-if="item.status === 'pending'">
                  <v-icon class="red--text">mdi-exclamation-thick</v-icon>
                </span>
                <span :title="item.name">{{ item.name | truncate(25) }}</span>
              </template>

              <template v-slot:[`item.address`]="{ item }">
                <span :title="item.address">
                  {{ item.address | truncate(20) }}
                </span>
              </template>
              <template v-slot:[`item.use_jwnet`]="{ item }">
                <span>
                  <template v-if="item.use_jwnet">○</template>
                </span>
              </template>
              <template v-slot:[`item.editable`]="{item}">
                <v-btn
                  v-if="$vuetify.breakpoint.mdAndUp"
                  icon
                  color="info darken-2"
                  @click="showButtonClickEvent(item)"
                >
                  <v-icon>mdi-file-document-outline</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  text
                  color="info"
                  @click="showButtonClickEvent(item)"
                >
                  参照する
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row
      v-if="hasResult"
      dense
    >
      <v-col>
        <v-pagination
          v-model="page"
          :length="pagination.total_pages"
          :total-visible="totalVisible"
          circle
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          @input="changePage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->

    <!-- /ダイアログ -->
    <subscriber-edit-dialog
      :enable-dialog="enableSubscriberDialog"
      :dialog-type="dialogType"
      @closeEvent="closeSubscriberDialog"
      @registerEvent="subscriberCallback"
    />
    <!-- ダイアログ -->
  </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import SubscriberEditDialog from '../../../../components/SubscriberEditDialog'
import DownloadMixin from '../../../../mixins/download-mixin'

export default {
  name: 'AdminMasterTransportIndex',
  components: {
    SubscriberEditDialog
  },
  filters: {},
  mixins: [
    DownloadMixin,
  ],
  props: {},
  data() {
    return {
      page: 1,
      totalVisible: 7,
      total_count: null,
      name: null,
      subscriber_number: null,  // 加入者番号
      unregisterTrader: false,

      enableSubscriberDialog: false,
      dialogType: 'admin_transport',
      tableHeaders: [
        { value: 'subscriber_number', text: '加入者番号' },
        { value: 'confirmation_number', text: '公開確認番号' },
        { value: 'name', text: '加入者名' },
        { value: 'zip_code', text: '郵便番号' },
        { value: 'address', text: '住所' },
        { value: 'use_jwnet', text: 'JWNET対象' },
        { value: 'editable', text: '詳細', align: 'end' },
      ],
      transports: []
    }
  },
  computed: {
    ...mapState('AdminMasterTransport', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
    ...mapGetters('AdminMasterTransport', [
      'hasResult'
    ]),
  },
  watch: {
    transportName (newVal) {
      this.saveCondition({ name: newVal })
    },
    transportSubscriberNumber (newVal) {
      this.saveCondition({ subscriber_number: newVal })
    },
  },
  created() {
    if (this.$route.params.resetCondition) {
      this.resetCondition()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    this.name = this.searchCondition.name
    this.subscriber_number = this.searchCondition.subscriber_number
    this.unregisterTrader = this.searchCondition.unregister_trader
    this.page = this.pagination.current_page
    this.searchTransports()
  },
  methods: {
    ...mapActions('AdminMasterTransport', {
      fetchTransports: 'index',
      saveCondition: 'saveCondition',
      resetCondition: 'resetState',
      resetPagination: 'resetPagination',
    }),

    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent () {
      this.page = 1
      this.searchTransports()
    },
    /**
     * 追加ボタン クリックイベント
     */
    addSubscriberButtonClickEvent () {
      this.enableSubscriberDialog = true
    },
    /**
     * モーダルを閉じる
     */
    closeSubscriberDialog () {
      this.enableSubscriberDialog = false;
    },
    /**
     * モーダルからのコールバック処理
     */
    subscriberCallback (forms) {
      this.resetPagination()
      this.page = this.pagination.current_page
      this.searchTransports()
      this.closeSubscriberDialog()
    },
    /**
     * 参照ボタンクリックイベント
     */
    showButtonClickEvent (item) {
      this.$router.push({name: 'AdminMasterTransport', params: { id: item.id }})
    },
    changePage () {
      this.searchTransports()
    },
     /**
     * 収集運搬業者検索
     */
    searchTransports () {
      let params = this.buildParam()
      this.fetchTransports(params).then((content) => {
        this.transports = content.transports
        this.total_count = content.pagination.total_count
      })
    },

    /*パラメータ設定 */
    buildParam() {
      return {
        name: this.name,
        subscriber_number: this.subscriber_number,
        unregister_trader: this.unregisterTrader,
        page: this.page
      }
    },
  }
}
</script>

<style scoped lang="scss">
.panel-header-color {
  color: #0D74BA !important;
  & .v-expansion-panel-header__icon {
    & .v-icon {
      color: #0D74BA !important;
      &::before {
        color: #0D74BA !important;
      }
    }
  }
}
.panel-selectable {
  background-color: #DCE7EB;
}

</style>
